import { Component } from '@angular/core';

import { Platform } from '@ionic/angular';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { StatusBar } from '@ionic-native/status-bar/ngx';
import { ApicallService } from './services/apicall.service';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss']
})
export class AppComponent {
  // variable for toggling side nav
  isSidenav: boolean = true;
  
  constructor(
    private platform: Platform,
    private splashScreen: SplashScreen,
    private statusBar: StatusBar,
    public apiCallService: ApicallService
  ) {
    this.initializeApp();
  }

  initializeApp() {
    this.platform.ready().then(() => {
      this.statusBar.styleDefault();
      this.splashScreen.hide();
    });
  }

  toggleSideNav = () => {
    this.isSidenav = !this.isSidenav;
  }

  isShowSideNav() {
    return this.isSidenav;
  }

  // activate the side bar only if user (agent) has pan number
  // this condition does not apply to staff
  activateSideBar() {
    if(this.apiCallService.user.approval_status==0 && this.apiCallService.user.roles[0].type === 'agent' || this.apiCallService.user.roles[0].type != 'agent' ){
      return !this.apiCallService?.user?.is_pan_number_blank;
    }
  }
}
